import { render, staticRenderFns } from "./action-card.vue?vue&type=template&id=4b62e084&scoped=true&"
import script from "./action-card.vue?vue&type=script&lang=js&"
export * from "./action-card.vue?vue&type=script&lang=js&"
import style0 from "./action-card.vue?vue&type=style&index=0&id=4b62e084&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b62e084",
  null
  
)

export default component.exports